/**
 * @generated SignedSource<<f5cdf6d9687d58ccfdcd393f4a8089a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseRelatedDesignsContainer_photos$data = {
  readonly facets: {
    readonly imageRoomTypeFacet: ReadonlyArray<{
      readonly label: string | null;
      readonly name: string | null;
    } | null> | null;
    readonly imageStyleFacet: ReadonlyArray<{
      readonly label: string | null;
      readonly name: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PhotosSearchBrowseRelatedDesignsContainer_photos";
};
export type PhotosSearchBrowseRelatedDesignsContainer_photos$key = {
  readonly " $data"?: PhotosSearchBrowseRelatedDesignsContainer_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseRelatedDesignsContainer_photos">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseRelatedDesignsContainer_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseFacets",
      "kind": "LinkedField",
      "name": "facets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageRoomTypeFacet",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageStyleFacet",
          "plural": true,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "f5acef6df07a7c9791ef0d520745f54d";

export default node;
